module.exports = __webpack_public_path__ + "img/logo_small_gray.c8f79a4d.png";